import React from 'react'

import { useRecentAccountsQuery, CardType } from '@edge/spark/io-dashboards'
import { SingleNumberWidget } from '../../BaseComponents/SingleNumberWidget'
import type { BasicWidgetProps } from '../../types'

const RECENT_ACCOUNT_MAX_AGE = 29
const SEARCH_STRING = `establishdate:${RECENT_ACCOUNT_MAX_AGE}`

const NewCustomersThisWeek = ({
    config: { text = 'New Customers', secondaryText = 'in the last 30 days', text2 = ' ' },
    widgetId,
    handleConfig,
    readonly,
}: BasicWidgetProps): React.ReactElement => {
    const { data, loading } = useRecentAccountsQuery({
        variables: { daysAgo: SEARCH_STRING },
    })

    const count = data?.auction?.search?.accountCount ?? '--'

    return (
        <SingleNumberWidget
            action={{
                text: 'View Customers',
                link: `/recentaccounts?`,
            }}
            cardType={CardType.CUSTOMER}
            number={count}
            text={text}
            text2={text2}
            secondaryText={secondaryText}
            loading={loading}
            widgetId={widgetId}
            handleConfig={handleConfig}
            readonly={readonly}
        />
    )
}

export default NewCustomersThisWeek
